import * as React from 'react';

const InfoIcon = ({ fill = 'black', fillOpacity = '0.75' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22.0005C17.52 22.0005 22 17.5205 22 12.0005C22 6.48049 17.52 2.00049 12 2.00049C6.48 2.00049 2 6.48049 2 12.0005C2 17.5205 6.48 22.0005 12 22.0005ZM11 7.00049L13 7.00049L13 9.00049L11 9.00049L11 7.00049ZM11 11.0005L13 11.0005L13 17.0005L11 17.0005L11 11.0005Z"
      fill={fill}
      fillOpacity={fillOpacity}
    />
  </svg>
);

export default InfoIcon;
